import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Sidebaritem from "../Sidebaritem/sidebaritem";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WorkOutlineOutlinedIcon from "@material-ui/icons/WorkOutlineOutlined";
import StarOutlineOutlinedIcon from "@material-ui/icons/StarOutlineOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";

import { Hidden } from "@material-ui/core";

const useStyles = makeStyles({
  sidebar: {
    position: "fixed",

    top: 0,
    left: 0,

    width: "20%",
    height: "100vh",

    display: "flex",
    flexDirection: "column",

    background: "#302f52",

    borderRight: "1px solid rgba(255, 255, 255, 0.08)",

    zIndex: 1000,

    boxSizing: "border-box",

    padding: "35px 12px",

    overflow: "hidden",
  },

  brand: {
    padding: "0 18px",

    marginBottom: "55px",
  },

  logo: {
    margin: 0,

    color: "#fff",

    fontSize: "32px",

    fontWeight: 800,

    letterSpacing: "-1.5px",
  },

  logoDot: {
    color: "#ff0055",
  },

  subtitle: {
    margin: "5px 0 0",

    color: "#8f8ea3",

    fontSize: "11px",

    letterSpacing: "2px",

    textTransform: "uppercase",
  },

  navigation: {
    display: "flex",

    flexDirection: "column",

    width: "100%",
  },

  navTitle: {
    margin: "0 18px 12px",

    color: "#66657b",

    fontSize: "10px",

    fontWeight: 700,

    letterSpacing: "2px",

    textTransform: "uppercase",
  },

  footer: {
    marginTop: "auto",

    padding: "20px 18px 5px",

    color: "#66657b",

    fontSize: "11px",

    lineHeight: 1.6,
  },

  footerAccent: {
    color: "#ff4f81",
  },
});

export default function Sidebar() {
  const classes = useStyles();

  const [activeSection, setActiveSection] = useState("profile");

  const navigation = [
    {
      id: "profile",
      label: "Home",
      icon: <HomeOutlinedIcon />,
    },
    {
      id: "about",
      label: "About",
      icon: <InfoOutlinedIcon />,
    },
    {
      id: "experience",
      label: "Experience",
      icon: <InfoOutlinedIcon />,
    },
    {
      id: "service",
      label: "Services",
      icon: <WorkOutlineOutlinedIcon />,
    },
    {
      id: "work",
      label: "Recent Work",
      icon: <StarOutlineOutlinedIcon />,
    },
    {
      id: "contact",
      label: "Contact",
      icon: <ForumOutlinedIcon />,
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sections = navigation
        .map((item) => document.getElementById(item.id))
        .filter(Boolean);

      const scrollPosition = window.scrollY + 250;

      let currentSection = "profile";

      sections.forEach((section) => {
        if (section.offsetTop <= scrollPosition) {
          currentSection = section.id;
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Hidden only={["xs", "sm", "md"]}>
      <aside className={classes.sidebar}>
        {/* Logo */}
        <div className={classes.brand}>
          <h1 className={classes.logo}>
            Laraib<span className={classes.logoDot}>.</span>
          </h1>

          <p className={classes.subtitle}>Full-Stack Developer</p>
        </div>

        {/* Navigation */}
        <nav className={classes.navigation}>
          <p className={classes.navTitle}>Navigation</p>

          {navigation.map((item) => (
            <Sidebaritem
              key={item.id}
              id={item.id}
              icon={item.icon}
              h3={item.label}
              active={activeSection === item.id}
              onClick={setActiveSection}
            />
          ))}
        </nav>

        {/* Footer */}
        <div className={classes.footer}>
          <div className={classes.copyright}>
            © {new Date().getFullYear()} Laraib. All rights reserved.
          </div>
        </div>
      </aside>
    </Hidden>
  );
}
